import * as fns from 'date-fns'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { Observable, observe, Scope } from 'wdc-cube'
import { Bordero, BorderoFilterParams } from './bordero.types'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class BorderoScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope

    @observe() borderos = [] as Bordero[]
    @observe() filtroDataInicial = fns.subDays(new Date(), 30) as Date
    @observe() filtroDataFinal = new Date()
    @observe() filtroStatus? = ''
    @observe() filtroIdBordero? = ''

    onFind = Scope.ASYNC_ACTION_ONE<BorderoFilterParams>()
    onNew = Scope.ASYNC_ACTION
    onReprocess = Scope.ASYNC_ACTION_ONE<number>()
    onDelete = Scope.ASYNC_ACTION_ONE<number>()
    onShowDetailedResults = Scope.ASYNC_ACTION_ONE<number>()
    onShowBorderoProcStatus = Scope.ASYNC_ACTION_ONE<number>()
}

export default BorderoScope
